<template>
  <div>
    <page-nav-bar
      :is-sticky="true"
      :back-button="true"
      :has-actions="false"
      :title="!parent ? 'Création d\'une Origine' : 'Création d\'une sous-origine'">
    </page-nav-bar>
    <page-content
      :has-no-padd-on-act-on-desktop="false"
      :set-main-col-class="'is-12 is-9-widescreen is-8-fullhd'">
      <div class="has-background-white is-border">
        <origin-form
          @submit="createOrigin"
          :parent="parent"
          :loading="loading"
          :submit-loading="submitLoading"></origin-form>
      </div>
    </page-content>
  </div>
</template>

<script>
export default {
  name: 'OriginCreate',
  components: {
    OriginForm: () => import('@/components/origin/OriginForm')
  },
  data () {
    return {
      parent: null,
      loading: false,
      submitLoading: false
    }
  },
  computed: {
    parentPk () {
      return this.$route.query.parent
    }
  },
  created () {
    if (this.parentPk) {
      this.getOrigin()
    }
  },
  methods: {
    async getOrigin () {
      this.loading = true
      try {
        let { data } = await this.$api.getOne(this.$resources.ORIGIN, this.parentPk)
        this.parent = data
        this.loading = false
      } catch (err) {
        this.loading = false
        console.log(err)
      }
    },
    async createOrigin (origin) {
      this.submitLoading = true
      if (this.parentPk) {
        origin.parent = this.parentPk
      }
      try {
        let { data } = await this.$api.post(this.$resources.ORIGIN, origin)
        this.$store.commit('addOrigin', { origin: data })
        if (data.parent) {
          this.$router.replace({ name: 'OriginVue', params: { id: data.parent.pk } })
        } else {
          this.$router.replace({ name: 'OriginVue', params: { id: data.pk } })
        }
        this.submitLoading = false
      } catch (err) {
        console.log(err)
        this.submitLoading = false
      }
    }
  }
}
</script>
